import { render, staticRenderFns } from "./ModalBatchSetting.vue?vue&type=template&id=1cc38fee&scoped=true"
import script from "./ModalBatchSetting.vue?vue&type=script&lang=js"
export * from "./ModalBatchSetting.vue?vue&type=script&lang=js"
import style0 from "./ModalBatchSetting.vue?vue&type=style&index=0&id=1cc38fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc38fee",
  null
  
)

export default component.exports